const login_r = 'login_r'
const login_s = 'login_s'
const login_f = 'login_f'

export {login_f,login_r,login_s}